import { ArrowLeftRight } from "lucide-react";
import { useSite } from "@/context/SiteContext";
import { PageHero, Reveal } from "@/components/site/Reveal";
import { LocationCard } from "@/components/site/LocationCard";
import { usePageMeta } from "@/lib/seo";

export default function Locations() {
  const { content } = useSite();
  usePageMeta(
    "Gym in Bayside Queens & Flushing Queens | Iron Pump Gym Locations",
    "Iron Pump Gym locations: 38-17 Bell Blvd, Bayside and 150-24 Northern Blvd (rear entrance), Flushing. Late night gym in Queens with a sauna in Flushing."
  );
  return (
    <>
      <PageHero eyebrow="Locations" title={<>Bayside <span className="text-gold-grad">+</span> Flushing</>}
        sub="Two gyms in Queens, both open late. Pick the one closest to home, work or wherever you are that day." image="/images/floor.webp" />
      <section className="mx-auto max-w-7xl px-4 py-16 sm:px-8">
        <Reveal>
          <div className="flex flex-col items-start gap-5 rounded-md border border-[var(--gold)]/30 bg-[var(--gold)]/[0.06] p-6 sm:flex-row sm:items-center sm:p-8" data-testid="one-membership-explainer">
            <ArrowLeftRight className="h-10 w-10 shrink-0 text-[var(--gold)]" />
            <div>
              <p className="h-display text-3xl text-white">One membership. Both gyms.</p>
              <p className="mt-1 text-sm text-white/65 sm:text-base">Every Iron Pump membership works at Bayside and Flushing. Lift in Bayside before work, hit the Flushing sauna after. No transfer fees, no extra cards.</p>
            </div>
          </div>
        </Reveal>
        <div className="mt-12 grid gap-8 lg:grid-cols-2">
          {content.locations.map((loc, i) => <Reveal key={loc.id} delay={i * 0.1}><LocationCard loc={loc} /></Reveal>)}
        </div>
      </section>
    </>
  );
}
